import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import { TECHNOLOGY_NAV_TABS, getTechnologyTabHref, getActiveTechnologyTabId } from '../../utils/technologyTabs';



const TechnologyTabNav = () => {

  const location = useLocation();

  const activeTabId = getActiveTechnologyTabId(location.pathname);



  return (

    <nav className="flex flex-wrap justify-center gap-2 mb-6 px-2" aria-label="Technology sections">

      {TECHNOLOGY_NAV_TABS.map((tab) => {

        const isActive = activeTabId === tab.id;

        return (

          <Link

            key={tab.id}

            to={getTechnologyTabHref(tab)}

            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${

              isActive

                ? 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 ring-1 ring-red-200 dark:ring-red-800'

                : 'bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-200 hover:bg-red-50 dark:hover:bg-red-900/20'

            }`}

          >

            {tab.emoji && (
              <span className="text-base leading-none shrink-0" aria-hidden="true">{tab.emoji}</span>
            )}

            {tab.label}

          </Link>

        );

      })}

    </nav>

  );

};



export default TechnologyTabNav;

